import { ReactNode } from 'react';

import { ThemeType } from '@lessonPlanner/constants';

import { DEFAULT_LAYOUT_STYLES } from '../../../constants/pptThemeLayouts';
import { ContentFormatter, SlideContent } from '../../../types/ppt-slide';

export interface BaseLayoutProps {
  content?: SlideContent;
  fontFamily: string;
  textColor: string;
  formatContentForPptContent: ContentFormatter;
  themeType: ThemeType;
}

export interface LayoutComponentProps extends BaseLayoutProps {
  children?: ReactNode;
}

export function BaseLayout({ children }: LayoutComponentProps) {
  return <>{children}</>;
}

export function ImagePlaceholder({
  content,
}: {
  content: SlideContent | undefined;
}) {
  return (
    <div className="h-full rounded bg-gray-200 p-2 text-center text-xs italic">
      {typeof content === 'object' && 'image' in content && content.image
        ? 'Image: ' + content?.image
        : 'Image placeholder'}
    </div>
  );
}

export enum TypographyElement {
  TITLE = 'title',
  CONTENT = 'content',
}

export function getTypographyFromTheme(
  themeType: ThemeType,
  layout: string,
  element: TypographyElement,
) {
  // First check if there's a theme-specific typography for this layout

  // Get layout config directly from DEFAULT_LAYOUT_STYLES
  const layoutConfig = DEFAULT_LAYOUT_STYLES[layout];

  // Check if the layout has typography settings
  const layoutTypography = layoutConfig?.typography?.[element] || {};

  return { ...layoutTypography };
}
